import { ChangeDetectorRef, Component } from "@angular/core";
import {
  AuditPermissionService,
  Country,
} from "@core/services/audit-permission.service";
import {
  FilterConfigType,
  TableColumn,
  TableComponent,
} from "@shared/components/table/table.component";
import { LazyLoadEvent } from "primeng/api";
import { LoaderService } from "@core/services/gigya/loader/loader.service";
import { finalize } from "rxjs";
import { AddProductFamilyComponent } from "./add-product-family/add-product-family.component";

@Component({
  selector: "app-product-family",
  imports: [TableComponent, AddProductFamilyComponent],
  templateUrl: "./product-family.component.html",
  styleUrl: "./product-family.component.scss",
})
export class ProductFamilyComponent {
  productFamilyData: Country[] = [];
  productFamilyColumns: TableColumn[] = [];
  productFamilyGlobalFilterFields: string[] = [];
  productFamilyFiltersConfig: FilterConfigType[] = [];
  productFamilyFiltersValue: { [key: string]: any } = {};
  openModal: boolean = false;

  productFamilyActions: any[] = [];

  productFamilyTotalRecords: number = 0;
  productFamilyLoading: boolean = false;
  productFamilyPage: number = 1;
  productFamilyPageSize: number = 10;
  productFamilyLastLazyLoadEvent: LazyLoadEvent | null = null;
  editData: any;
  editMode: boolean = false;
  constructor(
    private auditServices: AuditPermissionService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {}
  ngOnInit(): void {
    this.setTabConfig();
    this.getProductFamily();
  }

  setTabConfig(): void {
    this.productFamilyColumns = [
      { field: "sno", header: "S.No", sortable: false, width: "5%" },
      {
        field: "name",
        header: "Product Family",
        sortable: false,
        width: "20%",
      },

      {
        field: "_name",
        header: "",
        isAction: true,
      },
    ];

    this.productFamilyActions = [
      {
        label: "Edit",
        class: "edit-button",
        onClick: (row: any) => this.editUser(row),
      },
    ];
  }

  editUser(row: any) {
    this.editData = row;
    this.editMode = true;
    this.openModal = true;
  }
  onLazyLoadEventFromTable(event: LazyLoadEvent) {
    this.productFamilyLastLazyLoadEvent = event;
    this.productFamilyLoading = true;
    this.loaderService.show();
    const currentEvent = event ||
      this.productFamilyLastLazyLoadEvent || {
        first: 0,
        rows: this.productFamilyPageSize,
      };

    this.productFamilyPage =
      (currentEvent.first ?? 0) /
        (currentEvent.rows ?? this.productFamilyPageSize) +
      1;
    this.productFamilyPageSize =
      currentEvent.rows ?? this.productFamilyPageSize;
    this.getProductFamily();
  }

  getProductFamily() {
    this.auditServices
      .getProductFamily(this.productFamilyPage, this.productFamilyPageSize)
      .pipe(
        finalize(() => {
          this.productFamilyLoading = false;
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: (response: any) => {
          this.productFamilyData = response.product_families.map(
            (item: Country, index: any) => ({
              ...item,
              sno:
                (this.productFamilyPage - 1) * this.productFamilyPageSize +
                index +
                1,
            })
          );
          this.productFamilyTotalRecords = response?.meta.total;
          this.cdr.detectChanges();
        },
        error: (error) => {},
      });
  }
  Add() {
    this.openModal = true;
  }
  closeDialog(event: any) {
    this.openModal = false;
    this.editMode = false;
    this.getProductFamily();
  }
}
